import { connect } from 'react-redux'

import { doUploadFiles } from 'actions/attachments'
import { doRealtimeAgentStartTicketTypingNotification } from 'actions/realtime'
import { doMentionAgent } from 'actions/tickets'
import { doUpdateEditorVisibility } from 'ducks/editor/operations'

import {
  selectAttachmentsByDraftId,
  selectDraftByTicketId,
  selectDraftAssignmentLabelByTicketId,
} from 'ducks/drafts2/selectors'
import {
  debouncedHandleDraftChange,
  handleDraftChange,
  doDeleteDraft,
  doSendReplyDraft,
} from 'ducks/drafts2/operations'

import {
  doUpdateAgentMention,
  doUpdateSuppressMentionSelector,
} from 'actions/app'

import {
  selectShowMentionSelector,
  selectIsMentioningAgent,
  selectSelectedMentionSelectorAgentId,
  selectSuppressMentionSelector,
} from 'selectors/mentions'
import { doOpenTicketPage } from 'actions/pages'

import { selectCurrentConversationById } from 'ducks/tickets/selectors'
import { selectCurrentUserIsViewer } from 'ducks/currentUser/selectors'
import { selectPrefersAiEnabled } from 'selectors/app/selectAccountPreferences'
import { selectCurrentConversationIsFollowing } from 'ducks/tickets/selectors/selectCurrentConversationIsFollowing'

import View from './view'

const DRAFT_TYPE = 'note'
const select = () => {
  return (state, props) => {
    const { ticketId } = props
    const { isOpen, channel } =
      selectCurrentConversationById(state, ticketId) || {}
    const draft = selectDraftByTicketId(state, ticketId, DRAFT_TYPE) || {}
    const { id: draftId, assigneeGroupId, isSendable } = draft

    return {
      draftId,
      isOpen,
      assignmentLabel: selectDraftAssignmentLabelByTicketId(
        state,
        ticketId,
        DRAFT_TYPE
      ),
      assigneeGroupId,
      isSendable,
      showMentionSelector: selectShowMentionSelector(state),
      isMentioning: selectIsMentioningAgent(state),
      currentMailboxId: channel,
      selectedMentionSelectorAgentId: selectSelectedMentionSelectorAgentId(
        state
      ),
      suppressMentionSelector: selectSuppressMentionSelector(state),
      isTicketFollowing: selectCurrentConversationIsFollowing(state),
      attachments: selectAttachmentsByDraftId(state, draftId),
      isCurrentUserViewer: selectCurrentUserIsViewer(state),
      prefersAiEnabled: selectPrefersAiEnabled(state),
    }
  }
}

const perform = dispatch => {
  return {
    deleteDraft: (ticketId, draftId) => {
      if (draftId) {
        const msg = 'Are you sure you want to delete this draft?'
        if (!window.confirm(msg)) return // eslint-disable-line no-alert
        dispatch(doDeleteDraft(ticketId, draftId))
      } else {
        dispatch(doUpdateEditorVisibility(false))
      }
      dispatch(doOpenTicketPage(ticketId))
    },
    debouncedHandleDraftChange: (ticketId, prop, val, opts) => {
      const fields = { isNote: true, [prop]: val }
      const { draftId } = opts
      const messageId = null // not used yet
      debouncedHandleDraftChange(
        dispatch,
        DRAFT_TYPE,
        draftId,
        ticketId,
        messageId,
        fields
      )
    },
    handleDraftChange: (ticketId, prop, val, opts) => {
      const fields = { isNote: true, [prop]: val }
      const { draftId } = opts
      const messageId = null // not used yet
      handleDraftChange(
        dispatch,
        DRAFT_TYPE,
        draftId,
        ticketId,
        messageId,
        fields
      )
    },
    handleDraftMultiChange: (ticketId, fields, opts) => {
      const { draftId } = opts
      const noteFields = { ...fields, isNote: true }
      const messageId = null // not used yet
      handleDraftChange(
        dispatch,
        DRAFT_TYPE,
        draftId,
        ticketId,
        messageId,
        noteFields
      )
    },
    sendDraft: (draftId, follow) => {
      dispatch(doSendReplyDraft(draftId, follow))
    },
    uploadFiles: (...args) => {
      dispatch(doUploadFiles(...args))
    },
    doUpdateAgentMention: (...args) => {
      dispatch(doUpdateAgentMention(...args))
    },
    doMentionAgent: (...args) => {
      dispatch(doMentionAgent(...args))
    },
    doUpdateSuppressMentionSelector: (...args) => {
      dispatch(doUpdateSuppressMentionSelector(...args))
    },
    doRealtimeAgentStartTicketTypingNotification: (...args) => {
      dispatch(doRealtimeAgentStartTicketTypingNotification(...args))
    },
  }
}

export default connect(select, perform)(View)
